import { render, staticRenderFns } from "./assignment-task.vue?vue&type=template&id=c333d2f2"
import script from "./assignment-task.vue?vue&type=script&lang=js"
export * from "./assignment-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports